export interface SignUpDto {
  title: string // required title field
  firstName: string // required, minLength: 1
  lastName: string // required, minLength: 1
  email: string // required, minLength: 1, format: email
  phoneNo: string // required, minLength: 1
  password: string // required, minLength: 8
  gender?: GenderEnum
  parishOfOrigin?: string | null
  parishOfOriginLocation?: string | null
  sacraments?: SacramentEnum[] // Array of sacrament enum values
}

export interface LoginDto {
  email: string // required, minLength: 1
  password: string // required, minLength: 1
  keepLoggedIn?: boolean // This is frontend-only, not in Swagger spec
}

export interface LoginResponse {
  id: string
  roles: string[]
  token: string
  expiresIn: number
}

export interface MemberCreateDto {
  title?: string | null
  memberProfileImage?: string | null
  firstName: string // required, minLength: 1
  lastName: string // required, minLength: 1
  gender: GenderEnum // required
  emailAddress?: string | null
  mobileNo?: string | null
  idNumber?: string | null
  dob: string // required, date-time format
}

export interface MemberUpdateDto {
  title?: string | null
  memberNo?: number
  memberProfileImage?: string | null
  firstName?: string | null
  lastName?: string | null
  emailAddress?: string | null
  mobileNo?: string | null
  idNumber?: string | null
  gender?: GenderEnum
  dob?: string
  isActive?: boolean
}

export interface MemberSacramentCreateDto {
  sacrament?: SacramentEnum
  dateReceived?: string
  parishReceivedFrom?: string | null
  locationOfParish?: string | null
  image?: string | null
}

export interface MemberSacramentUpdateDto {
  sacrament?: SacramentEnum
  dateReceived?: string // Consider using Date or string with proper format handling
  parishReceivedFrom?: string | null
  locationOfParish?: string | null
  image?: string | null
}

export interface ApprovalDto {
  approvalStatus?: ApprovalStatus
}

export enum SacramentEnum {
  Baptism = 0,
  Eucharist = 1,
  Confirmation = 2,
  Priest = 3,
  Religious = 4,
  Matrimony = 5,
}

export enum GenderEnum {
  Male = 0,
  Female = 1,
}

export enum ApprovalStatus {
  NotApproved = 0,
  Approved = 1,
  Rejected = 2, // Added missing status from Swagger spec
}

export enum RelationShipType {
  Parent = 0,
  Child = 1,
  Sibling = 2,
  Spouse = 3,
}

export interface PasswordChangeDto {
  memberProfileId?: string // UUID format
  newPassword?: string | null
}

export interface LockAccountDto {
  lockAccount?: boolean
  memberId?: string // UUID format
}

export interface RelationShipCreateDto {
  memberId: string // UUID format - required
  relatedMemberId: string // UUID format - required
  relationShipType: RelationShipType // required
}

export type TitleType = 'Mr' | 'Mrs' | 'Ms' | 'Miss' | 'Master' | 'Father' | 'Brother' | 'Sister' | 'Dr'
